import Collapse from './Collapse';

export default Collapse;
export const Panel = Collapse.Panel;
